const metricsActions = {
  SHOW_METRICS: 'SHOW_METRICS',
  SHOW_METRICS_ERROR: 'SHOW_METRICS_ERROR',
  FETCH_METRICS: 'FETCH_METRICS',
};

export const dataPoints = {
  INTERNAL: 'total_internal',
  PRIVATE: 'total_private',
  PUBLIC: 'total_public',
};

export default metricsActions;
